var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyMessage = function SvgEmptyMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8733 23.9205V11.7829C65.8733 6.0306 61.1669 1.32422 55.4146 1.32422H11.7829C6.0306 1.32422 1.32422 6.0306 1.32422 11.7829V43.5587C1.32422 49.3109 6.0306 54.0174 11.7829 54.0174H35.3995C37.0211 54.0174 38.3355 55.3321 38.3355 56.9535V64.7374C38.3355 66.263 40.253 66.9415 41.2125 65.7556L49.6572 55.3185C50.3229 54.4958 51.3248 54.0176 52.3832 54.0176H55.4146C61.1669 54.0176 65.8733 49.3112 65.8733 43.5589V29.9907",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6914 17.5996C32.6914 16.9093 33.2511 16.3496 33.9414 16.3496C34.6318 16.3496 35.1914 16.9093 35.1914 17.5996V36.1796C35.1914 36.87 34.6318 37.4296 33.9414 37.4296C33.2511 37.4296 32.6914 36.87 32.6914 36.1796V17.5996Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2305 25.6406C43.9208 25.6406 44.4805 26.2003 44.4805 26.8906C44.4805 27.581 43.9208 28.1406 43.2305 28.1406L24.6505 28.1406C23.9601 28.1406 23.4005 27.581 23.4005 26.8906C23.4005 26.2003 23.9601 25.6406 24.6505 25.6406L43.2305 25.6406Z",
    fill: "#757575"
  })));
};
export default SvgEmptyMessage;